import { css } from "emotion";
import { Component } from "preact";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import H4 from "../../../components/global/H4";
import P from "../../../components/global/P";
import Image from "../../../components/Image";
import ContentBlock from "../../../components/layout/ContentBlock";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import FAQS from "../FAQS";
import GeneralForm from "../forms/GeneralForm";

const contactIcon = require("../../../assets/ic_general_support_blue_small.svg");
const faqIcon = require("../../../assets/ic_faqs_purple.svg");

const emailIcon = require("../../../assets/ic_email_form.svg");

const wrapper = css({
  textAlign: "center",
  maxWidth: 700,
  margin: "0 auto",
  h2: {
    marginBottom: 16
  },
  p: {
    marginBottom: 40
  }
});

const heading = css({
  display: "flex",
  alignItems: "center",
  marginBottom: 24,
  textAlign: "left",
  img: {
    marginRight: 12
  }
});

const faqs = [
  {
    link:
      "https://humanitix.helpdocs.io/article/t1cs1vc2v3-i-don-t-recognise-a-credit-card-charge-from-humanitix",
    text: "I don't recognise a credit card charge from Humanitix"
  },
  {
    link: "https://humanitix.helpdocs.io/article/l602vi9vvj-why-humanitix",
    text: "Why Humanitix?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/765ifbmhej-if-humanitix-donates-100-of-its-profits-to-education-projects-how-do-you-make-money",
    text:
      "If Humanitix donates 100% of its profits to education projects, how do you make money?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/dsocyv5xgu-i-m-a-charity-or-running-an-event-for-a-charity-and-we-want-to-partner-with-humanitix-what-do-you-look-for-in-a-partner",
    text:
      "I’m a charity, or running an event for a charity, and we want to partner with Humanitix What do you look for in a partner?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/qevftsk3hm-can-i-nominate-a-charity-that-s-not-a-partner",
    text: "Can I nominate a charity that’s not a partner?"
  }
];

class GeneralSupport extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateTitle("General Support");
  }

  render() {
    const { localeData, locale } = this.props;
    return (
      <Layout>
        <ContentBlock color="grey">
          <div className={wrapper}>
            <H2>General Support</H2>
            <P>
              Check some of our FAQs, if that doesn't work for you, send an
              enquiry to our human 🙂{" "}
            </P>
            <FAQS faqs={faqs} />
            <div className={heading}>
              <Image imageURL={emailIcon} alt="" />
              <H4>Send us a message</H4>
            </div>
            <GeneralForm locale={locale} />
          </div>
        </ContentBlock>
      </Layout>
    );
  }
}

export default CMSComponent(null, GeneralSupport);
